module.exports = __webpack_public_path__ + "static/media/openloop_charge_tag.46bfa96f.png";